import { FFContextProvider } from '@harnessio/ff-react-client-sdk';
import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.scss';
import NoInternetConnection from './components/common/NoInternetConnection';
import settings from './constants/constants';
import AppRoutes from './routes/routes';
import { getUser } from './services/authentication.service';

function App() {
  const user = getUser();
  const email = user?.user?.email || '';

  return (
    <>
      <NoInternetConnection>
        <ToastContainer
          position='top-right'
          autoClose={7500}
          hideProgressBar={true}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          pauseOnHover
        />
        <FFContextProvider
          apiKey={settings.FeatureFlagSDKKey}
          target={{
            identifier: 'montu-leafio-frontend',
            name: 'Montu Leafio Frontend',
            attributes: {
              email,
            }
          }}
          async
        >
          <AppRoutes />
        </FFContextProvider>
      </NoInternetConnection>
    </>
  );
}

export default App;
